import { useFlag } from '@unleash/proxy-client-react';
import { useEffect } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { update } from '../../redux/features/config/config.slice';
import { setAuthRefactorFeatureFlag } from '../../utils/session-storage';
import { setAgentInactivityFeatureFlag } from '../../utils/session-storage';

const useUnleashHooks = () => {
  const audioBackend = useFlag('audio_backend');
  const autoCombo = useFlag('auto_combo');
  const bmAutoCombo = useFlag('bm_auto_combo');
  const authRefactor = useFlag('auth_refactor');
  const agentInactivityRefactor = useFlag('agent_inactivity_refactor');
  const finalOrderValidation = useFlag('final_order_validation');
  const posCart = useFlag('pos_cart');
  const loyaltySupport = useFlag('loyalty_support');
  const itemConversion = useFlag('item_conversion');
  const ocbReadback = useFlag('ocb_readback');

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(update({ FEATURE_FLAG_AUDIO_BACKEND: audioBackend }));
  }, [audioBackend]);

  useEffect(() => {
    dispatch(update({ FEATURE_FLAG_AUTO_COMBO: autoCombo }));
  }, [autoCombo]);

  useEffect(() => {
    dispatch(update({ FEATURE_FLAG_BM_AUTO_COMBO: bmAutoCombo }));
  }, [bmAutoCombo]);

  useEffect(() => {
    dispatch(update({ FEATURE_FLAG_LOYALTY_SUPPORT: loyaltySupport }));
  }, [loyaltySupport]);

  useEffect(() => {
    setAgentInactivityFeatureFlag((!!agentInactivityRefactor).toString());
  }, [agentInactivityRefactor]);

  useEffect(() => {
    setAuthRefactorFeatureFlag((!!authRefactor).toString());
  }, [authRefactor]);
  useEffect(() => {
    dispatch(
      update({ FEATURE_FLAG_FINAL_ORDER_VALIDATION: finalOrderValidation })
    );
  }, [finalOrderValidation]);
  useEffect(() => {
    dispatch(update({ FEATURE_FLAG_POS_CART: posCart }));
  }, [posCart]);
  useEffect(() => {
    dispatch(update({ FEATURE_FLAG_ITEM_CONVERSION: itemConversion }));
  }, [itemConversion, dispatch]);

  useEffect(() => {
    dispatch(update({ FEATURE_FLAG_OCB_READBACK: ocbReadback }));
  }, [ocbReadback]);
};

export default useUnleashHooks;
